import React from 'react';
import ReactJWPlayer from 'react-jw-player';
import { withStyles } from '@material-ui/core';
import { ATTEND_API_URL, EVENT_ID, getUserID, JWPLAYER_ID } from '../constants';
import './VideoPlayer.css';

const styles = (theme) => ({
  player: {
    '& .jw-logo-button': {
      display: 'none !important',
    },
  },
});
let si;

/**
 * Satellite Session 에서 사용하는 Player
 * - play 시간 기록
 * - complete 시 콜백함수 호출
 * - seek 되지 않도록 제어 (키 이벤트, ui)
 */
class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.type ? this.props.type : 'jw',
      src: this.props.src,
    };
    this.onReady = this.onReady.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onTime = this.onTime.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.updatePlayTime = this.updatePlayTime.bind(this);
  }

  keydownListener(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }

  keyupListener(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.keydownListener.bind(this), true);
    window.addEventListener('keyup', this.keyupListener.bind(this), true);
  }

  componentWillUnmount() {
    if (si) clearInterval(si);
    window.removeEventListener('keydown', this.keydownListener.bind(this), false);
    window.removeEventListener('keyup', this.keyupListener.bind(this), false);
  }

  onReady(val) {
    console.log('onReady', val);

    fetch(`${ATTEND_API_URL}/attend/playCheck?evt=${EVENT_ID}&userid=${getUserID()}&program=${this.props.pgmId}&etDate=${this.props.sd}`, {
      method: 'POST',
    })
      .then((res) => res.text())
      .then((body) => {
        const res = JSON.parse(body);
        console.log(res);
        if (res.Items.length > 0) {
          console.log(res.Items[0].playTime);
          if (res.Items[0].playTime && res.Items[0].playTime > 0) {
            sessionStorage.setItem(getUserID() + '_' + this.props.pgmId, res.Items[0].playTime);
            this.setState({ playTime: res.Items[0].playTime });
          }
          // player.seek(300);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onComplete() {
    console.log('onComplete >>>');
    localStorage.setItem(getUserID() + '_' + this.props.pgmId + '_complete', new Date().getTime().toString());
    this.props.onComplete();
  }

  onPlay(val) {
    console.log('onPlay', val);
    this.props.onPlay();
    const player = window.jwplayer(JWPLAYER_ID);
    if (this.state.playTime) {
      let _time = this.state.playTime;
      if (Number(_time) >= Number(player.getDuration()) - 5) {
        _time = 0;
      }
      player.seek(_time);
    }

    fetch(
      `${ATTEND_API_URL}/attend/play?evt=${EVENT_ID}&userid=${getUserID()}&program=${this.props.pgmId}&etDate=${
        this.props.sd
      }&playTime=${player.getCurrentTime()}`,
      {
        method: 'POST',
      },
    )
      .then((res) => {})
      .then((body) => {})
      .catch((err) => {
        console.log(err);
      });

    if (si) clearInterval(si);
    si = setInterval(this.updatePlayTime, 1000 * 10);
  }

  onPause(val) {
    console.log('onPause', val);
    this.updatePlayTime();
  }

  updatePlayTime() {
    const player = window.jwplayer(JWPLAYER_ID);
    if (player) {
      let pt = player.getCurrentTime();
      console.log('updateTime', pt);
      sessionStorage.setItem(getUserID() + '_' + this.props.pgmId, pt);
      if (pt > 0) {
        fetch(
          `${ATTEND_API_URL}/attend/play?evt=${EVENT_ID}&userid=${getUserID()}&program=${this.props.pgmId}&etDate=${
            this.props.sd
          }&playTime=${pt}`,
          {
            method: 'POST',
          },
        )
          .then((res) => res.text())
          .then((body) => {})
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }

  onTime(val) {
    // console.log('onTime', val);
  }

  render() {
    const playlist = [
      {
        file: this.state.src,
      },
    ];
    const { classes } = this.props;
    return (
      <div style={{ width: '100%' }} className={'main'}>
        <ReactJWPlayer
          className={classes.player}
          playerId={JWPLAYER_ID}
          playerScript={`https://cdn.jwplayer.com/libraries/${JWPLAYER_ID}.js`}
          playlist={playlist}
          isAutoPlay={false}
          onReady={this.onReady}
          onPlay={this.onPlay}
          onPause={this.onPause}
          onTime={this.onTime}
          onComplete={this.onComplete}
        />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(VideoPlayer);
